module.exports = __webpack_public_path__ + "instagram-video-shadow.cdf2865ed301f2d77fd8f1d001f12ba0.svg";